import Popper from 'popper.js'
import Vue from 'vue'
class Ctor {
  constructor () {
    this.popperEl = null
    this.popperJS = null
    this.VM = null
    this.PopperVM = Vue.extend({
      data () {
        return {
          prefixCls: '',
          disabled: '',
          visible: '',
          always: '',
          content: '',
          ellipsis: '',
          placement: 'bottom'
        }
      },
      computed: {
        classes () {
          return [ this.prefixCls, {
            [`text-truncate`]: this.ellipsis
          }]
        }
      },
      template: `<transition name="fade">
    <div :class="classes" v-show="!disabled && (visible || always)">
      <div :class="[prefixCls + '-content']">
        <div :class="[prefixCls + '-arrow']"></div>
        <div :class="[prefixCls + '-inner']">
          <slot><div v-html="content"></div></slot>
        </div>
      </div>
    </div>
  </transition>`
    })
  }

  setVisible (e, opts, binding, el, flag) {
    if (opts.disabled === true) return
    setTimeout(() => {
      let ops = e.target.dataset
      ops.visible = flag
      let options = {
        prefixCls: ops.prefixCls,
        disabled: !!parseInt(ops.disabled),
        visible: !!parseInt(ops.visible),
        always: !!parseInt(ops.always),
        content: ops.content,
        ellipsis: !!parseInt(ops.ellipsis),
        placement: ops.placement
      }
      Object.keys(options).map(key => {
        if (this.VM) {
          this.VM.$set(this.VM.$data, key, options[key])
        }
        if (key !== 'onPopperShow' && key !== 'onPopperHide') {
          switch (Object.prototype.toString.call(options[key])) {
            case '[object String]':
            case '[object Number]':
              el.dataset[key] = options[key]
              break
            case '[object Boolean]':
              el.dataset[key] = options[key] ? 1 : 0
              break
            default:
              el.dataset[key] = options[key] ? options[key] : 0
              break
          }
        }
      })
      this.popperJS ? this.popperJS.update() : this.createPopper(ops, options, {
        gpuAcceleration: false,
        boundariesElement: 'viewport',
        forceAbsolute: true
      }, el)
      if (!options.always) {
        if (options.visible) {
          binding.value.onPopperShow && binding.value.onPopperShow()
        } else {
          binding.value.onPopperHide && binding.value.onPopperHide()
        }
      }
    }, opts.delay)
  }

  createPopper (options, binding, popperOpt, el) {
    let PopperVM = this.PopperVM
    this.VM = new PopperVM({
      data: {
        prefixCls: options.prefixCls,
        disabled: !!parseInt(options.disabled),
        visible: !!parseInt(options.visible),
        always: !!parseInt(options.always),
        content: options.content,
        ellipsis: !!parseInt(options.ellipsis),
        placement: options.placement
      }
    })
    options = {
      prefixCls: options.prefixCls,
      disabled: !!parseInt(options.disabled),
      visible: !!parseInt(options.visible),
      always: !!parseInt(options.always),
      content: options.content,
      ellipsis: !!parseInt(options.ellipsis),
      placement: options.placement
    }
    Object.assign(options, binding.value)
    Object.keys(options).map(key => {
      if (key !== 'onPopperShow' && key !== 'onPopperHide') {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
    const popper = this.popperEl = this.VM && this.VM.$mount().$el ? this.VM.$mount().$el : ''
    const reference = el
    if (!popper || !reference) return
    if (this.popperJS && this.popperJS.hasOwnProperty('destroy')) {
      this.popperJS.destroy()
    }
    document.body.appendChild(popper)
    const isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1
    const boundariesElement = isIE10 === true ? 'body' : 'viewport'
    popperOpt.placement = options.placement
    popperOpt.modifiers = {
      preventOverflow: {
        boundariesElement: boundariesElement
      },
      computeStyle: {
        gpuAcceleration: false
      }
    }
    this.popperJS = new Popper(reference, popper, popperOpt)
  }

  updatePopperOps (el, binding) {
    let ops = el.dataset
    ops.visible = 0
    let options = {
      prefixCls: ops.prefixCls,
      disabled: !!parseInt(ops.disabled),
      visible: !!parseInt(ops.visible),
      always: !!parseInt(ops.always),
      content: ops.content,
      ellipsis: !!parseInt(ops.ellipsis),
      placement: ops.placement
    }
    Object.assign(options, binding.value)
    Object.keys(options).map(key => {
      if (key !== 'onPopperShow' && key !== 'onPopperHide') {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
  }

  destoryPopper () {
    const popper = this.popperEl
    if (this.popperJS && popper) {
      if (popper.parentNode) {
        popper.parentNode.removeChild(popper)
      } else {
        this.popperJS.popper.parentNode.removeChild(this.popperJS.popper)
      }
      this.popperJS.destroy()
      this.popperJS = null
    }
  }
}

export default Ctor



// WEBPACK FOOTER //
// ./src/components/tooltip/ctor.js